define("shared/modifiers/perfect-scroll", ["exports", "@ember/debug", "@ember/service", "ember-modifier", "perfect-scrollbar"], function (_exports, _debug, _service, _emberModifier, _perfectScrollbar) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/service",0,"ember-modifier",0,"perfect-scrollbar"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  /**
   * This handles initializing and destroying a Perfect Scrollbar instance
   * on the target element.
   *
   * @example
   * ```
   * <div {{perfect-scroll "id-1"}}></div>
   * ```
   *
   * @example
   * Updates the Perfect Scrollbar instance whenever `isRunning` changes.
   * Useful for when an element's contents are populated after initial render.
   * ```
   * <div {{perfect-scroll updateTrigger=this.isRunning}}>
   * ```
   *
   * @example
   * Creates a Perfect Scrollbar instance with specific Perfect Scrollbar Options applied.
   * ```
   * <div {{perfect-scroll
   *  wheelPropagation=true
   *  suppressScrollX=true
   *  maxScrollbarLength=150}}
   * >
   * ```
   */
  let PerfectScrollModifier = _exports.default = (_dec = (0, _service.inject)(), (_class = class PerfectScrollModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "perfectScroll", _descriptor, this);
    }
    get id() {
      return this.args.positional[0];
    }

    /**
     * The named arguments, without updateTrigger as it's not a Perfect Scrollbar
     * option. See https://github.com/mdbootstrap/perfect-scrollbar#options
     */
    get scrollOptions() {
      const perfectScrollOptions = {
        ...this.args.named
      };
      delete perfectScrollOptions.updateTrigger;
      return perfectScrollOptions;
    }
    didReceiveArguments() {
      (false && !(this.perfectScroll) && (0, _debug.assert)('If you are inside an engine, inject the perfect-scroll service into that engine', this.perfectScroll));
      this.scrollbar = new _perfectScrollbar.default(this.element, this.scrollOptions);
      if (this.id) {
        this.perfectScroll.saveScrollbarToCache(this.id, this.scrollbar);
      }
    }
    willRemove() {
      this.scrollbar.destroy();
      if (this.id) {
        this.perfectScroll.removeScrollbarFromCache(this.id);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "perfectScroll", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
});